

/* eslint-disable import/no-unresolved */
const base = require('onestic-base/components/footer');
const utils = require('onestic-base/utils');
const preHome = require('./preHome');


module.exports = {
    base,
    loadCountriesLanguages() {
        const prehomeContent = $('#prehomecontent');
        if (prehomeContent.length) {
            const loadPrehomeUrl = prehomeContent.attr('data-url');
            if (loadPrehomeUrl) {
                $.ajax({
                    url: loadPrehomeUrl,
                    method: 'GET',
                }).done((data) => {
                    if (data.renderedTemplate) {
                        prehomeContent.html('').append(data.renderedTemplate);

                        const countries = $('#countrySite');
                        const languages = $('#language');
                        if (countries.length) {
                            const footerCountriesComponent = $('.countriesFooter');
                            if (footerCountriesComponent.length) {
                                const country = utils.getCookie('countryAndState');
                                if (country) {
                                    const countriesFooter = countries.clone().attr('id', 'countrySiteFooter')
                                        .attr('aria-label', $('label[for="countrySite"]').first().text().trim());
                                    footerCountriesComponent.append(countriesFooter);
                                    footerCountriesComponent.find(`option[value='${country.toLowerCase()}']`).prop('selected', true);
                                }
                            }
                        }
                        if (languages.length) {
                            const footerLanguagesComponent = $('.languagesFooter');
                            if (footerLanguagesComponent.length) {
                                const locale = utils.getCookie('locale');
                                if (locale) {
                                    const languagesFooter = languages.clone().attr('id', 'languageFooter')
                                        .attr('aria-label', $('label[for="language"]').first().text().trim());
                                    footerLanguagesComponent.append(languagesFooter);
                                    footerLanguagesComponent.find(`option[value='${locale.toLowerCase()}']`).prop('selected', true);
                                    footerLanguagesComponent.find('option').each((index, option) => {
                                        const homeUrl = $(option).attr('data-urlhome');
                                        $(option).attr('data-url', homeUrl);
                                    });
                                }
                            }
                        }

                        preHome.loadSelector();
                    }
                });
            }
        }
    },

};
